import React from 'react';
import { useTranslation } from "react-i18next";
import Box from '@mui/material/Box';
import Alert from "@mui/material/Alert";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import UpdateIcon from "@mui/icons-material/Update";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";

export default function FoodOrderMessage({value}) {

    const { t } = useTranslation();

    console.log('value', value);

    return (
        <Box>
            {value && value.payment.status === 'pending' &&
                <Box p={1} pb={0}>
                    <Alert icon={false} severity="warning">
                        <List sx={{padding: 0}}>
                            <ListItem sx={{padding: 0}}>
                                <ListItemAvatar>
                                    <UpdateIcon sx={{fontSize: 40}} />
                                </ListItemAvatar>
                                <ListItemText primary={t('cart.pendingPayment')} secondary={
                                    <Typography variant="body1">
                                        {t('cart.pendingPaymentMessage', {orderNo: value.transactionNo})}
                                    </Typography>
                                } />
                            </ListItem>
                        </List>
                    </Alert>
                </Box>
            }
        </Box>
    );
}
